export const PostgreSqlErrorCode = {
  UNIQUE_VIOLATION: "23505",
} as const;

export type PostgreSqlErrorCode = (typeof PostgreSqlErrorCode)[keyof typeof PostgreSqlErrorCode];

export function hasPostgreSqlErrorCode(error: unknown, code: PostgreSqlErrorCode): boolean {
  return typeof error === "object" && error !== null && "code" in error && error.code === code;
}
